import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ApprovalList from './ApprovalListComponent';
import * as actions from '../actions/ApprovalsActions';
import coreActions from '../../core/actions';

const allActions = { ...actions, ...coreActions };

const mapStateToProps = (state) => ({
  config: state.config,
  total: state.approvals.total,
  items: state.approvals.items,
  isLoading: state.approvals.isLoading,
});

const mapDispatchToProps = (dispatch) => ({ actions: bindActionCreators(allActions, dispatch) });

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalList);
